var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowernav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 125,
    viewBox: "0 0 203 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.405 70.8925C202.401 70.8886 163.657 6.4173 76.974 0.715179C5.39973 -3.98802 0.812513 57.6417 0.812513 57.6417C0.812513 57.6417 4.26987 119.802 75.8479 124.503C162.529 130.206 202.401 70.9029 202.405 70.8925Z",
    fill: "#00A560",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 70.6998C200.813 70.6961 163.407 8.94229 80.7602 2.95367C12.5186 -1.98632 8.6106 56.7823 8.6106 56.7823C8.6106 56.7823 12.3726 116.108 80.6177 121.046C163.263 127.036 200.812 70.7098 200.816 70.6998Z",
    fill: "#00A560",
    fillOpacity: 0.52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.28 70.807C198.276 70.8034 162.567 12.3348 84.6984 6.13879C20.4026 1.02723 17.1876 56.4065 17.1876 56.4065C17.1876 56.4065 21.1991 112.362 85.4982 117.472C163.365 123.669 198.276 70.8163 198.28 70.807Z",
    fill: "#00A560"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowernav);
export default __webpack_public_path__ + "static/media/flowernav.3ec5167f7ab7d4e31b04a066f71f7bd9.svg";
export { ForwardRef as ReactComponent };